// extracted by mini-css-extract-plugin
export default {"main":"OpportunityCollaborators_main__DQ5Q5","title":"OpportunityCollaborators_title__yLXDP"};